import { useEffect } from "react";

const STORAGE_KEY = "display_mode";

/**
 * Imposta html[data-display] ("tv" | "default").
 * Priorità: ?display=tv|default nell'URL (salvato), poi localStorage, poi utenti TANK → "tv".
 */
export default function useDisplayMode(userType) {
  useEffect(() => {
    const fromUrl = new URLSearchParams(window.location.search).get("display");
    if (fromUrl === "tv" || fromUrl === "default") localStorage.setItem(STORAGE_KEY, fromUrl);

    const mode = localStorage.getItem(STORAGE_KEY) || (userType === "TANK" ? "tv" : "default");
    document.documentElement.dataset.display = mode;
  }, [userType]);
}
